import React, {useContext} from 'react'
import {FormattedMessage} from 'react-intl'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {deleteAccount} from '../../../actions/account'
import {AuthType, UserType} from '../../../config/constants'
import {IState} from '../../../config/store'
import {getAuthUrl} from '../../../helpers/util'
import {RouterContext} from '../../containers/Context'
import {useLocale, useQueryObj, useUnmountedRef, useUserType} from '../../hocs/hooks'
import styles from '../login/Login.scss'

const CancelSignup = () => {
  const loggedIn = useSelector(({ session: {loggedIn }, }: IState) => loggedIn)
  const unmountedRef = useUnmountedRef()
  const queryObj = useQueryObj()
  const {history} = useContext(RouterContext)!
  const userType = useUserType()
  const locale = useLocale()
  const removeAccount = async () => {
    await deleteAccount()
    if (unmountedRef.current) return
    history.push(queryObj({auth: undefined}))
  }
  return <>
    {loggedIn
      ? <Link className={['text-right pt-2 pb-4', styles.underlineLink].join(' ')}
          onClick={removeAccount}
          to="#">
        <FormattedMessage defaultMessage="Cancel" id="signup.cancelBtnLabel"/>
      </Link>
      : <Link className={['text-right pt-2 pb-4', styles.underlineLink].join(' ')}
              to={getAuthUrl(locale, userType, AuthType.login)}>
        {userType === UserType.user && <FormattedMessage id="userType.driver">
          {msg => <FormattedMessage defaultMessage="Already have an {name} account, please login here"
                                    id="signup.driverLoginHere"
                                    values={{name: msg}}
          />}
        </FormattedMessage>}
        {userType === UserType.holder && 'すでにホルダーアカウントをお持ちの方'}
        {userType === UserType.host && 'すでにホストアカウントをお持ちの方'}
        {![UserType.user, UserType.holder, UserType.host].includes(userType)
        && <FormattedMessage defaultMessage="Already have an account, please login here"
                          id="signup.loginHere"
        />}
      </Link>}
  </>
}
CancelSignup.displayName = 'CancelSignup'
export default CancelSignup
